import { compose, propEq, find } from 'ramda'

export const getUpgradePopupProfileImage = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_PROFILE_IMG'))
)
